/* global Ad */
function filterFormUnconfigured($, document, window, $post, initDatepickerRange, selectors) {
    const form = document.querySelector(selectors.form);

    if (form) {
        initDatepickerRange(
            selectors.from,
            selectors.to,
            { currentText: $('#currentText').data('text') },
        );

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            submitFilterForm();
        });

        initSort($, document, {
            sort: selectors.sort,
            sortChangedCallback: () => { submitFilterForm(); },
        });
    }

    function submitFilterForm() {
        const generateFiltersUrl = document.querySelector(selectors.form).getAttribute('action');
        $(selectors.loader).show();

        $post(generateFiltersUrl, {
            from: document.querySelector(selectors.from).value,
            to: document.querySelector(selectors.to).value,
            persons: document.querySelector(selectors.persons).value,
            sort: document.querySelector(selectors.sort).value,
        }).then((data) => {
            window.location.href = data.currentUrl;
        });
    }
}

function initSort($, document, { sort, sortChangedCallback }) {
    const $sortField = $(sort);
    $(document).off('click', '.sortResults');
    $(document).off('click', '.sortTrigger');

    $(document).on('click', '.sortResults', function toggleSort() {
        $(this).find('ul').toggle(200);
    });

    $(document).on('click', '.sortTrigger', function selectSort(e) {
        const selectedSort = $(this).data('value');
        e.preventDefault();

        if ($(this).hasClass('disabled')) {
            return false;
        }

        if ($sortField.val() !== selectedSort) {
            showSelectedSort($(this));
            toggleActiveSort($(this));

            $sortField.val($(this).data('value'));
            sortChangedCallback();
        }

        return true;
    });

    function toggleActiveSort($selected) {
        $('.sortResults span.active').removeClass('active');
        $selected.addClass('active');
    }

    function showSelectedSort($selected) {
        const $selectedSortClone = $selected.clone().removeClass('sortTrigger');
        $('.sortResults>span').remove();
        $('.sortResults').prepend($selectedSortClone);
    }
}

const favoriteFilter = (options) => filterFormUnconfigured.bind(
    null,
    $,
    document,
    window,
    $.post,
    Ad.Datepicker.initRange,
    options,
);

export default favoriteFilter;
export { filterFormUnconfigured };
